module.exports = __webpack_public_path__ + "img/home-back.190db460.jpeg";